<template>
  <v-app id="inspire">
    <v-dialog v-model="loading" max-width="290">
      <v-card>
        <v-card-text>
          <v-layout flex align-center justify-center>
            <v-flex xs12 class="text-xs-center">
              <v-progress-circular
              indeterminate
              color="primary"
              :size="50"></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar color="pink darken-3" multi-line
                  top
                  v-model="resetAlert">
                  {{ mssg }}
                  <v-btn flat color="pink" @click.native="resetAlert = false">Fermer</v-btn>
                </v-snackbar>
                  <table width="100%">
    <tr>
      <td>
        <v-btn class="text-xs-left"  flat icon router :to="'/landing'"><v-icon medium color="orange darken-4">fa-chevron-left </v-icon></v-btn>
      </td>
      <td align="right">
        <v-btn class="text-xs-right" flat  color="orange darken-4" router :to="'/landing'">Fermer</v-btn>
      </td>
    </tr>
  </table>
    <v-content>
      <v-container fluid fill-height text-xs-center>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <h2>Je me connecte</h2><br/>
            <v-form>
              <v-text-field :rules="[rules.required, rules.email]" clearable v-model="email" prepend-icon="person" name="login" label="E-mail" type="email"></v-text-field>
              <v-text-field 
              :rules="[rules.required]" 
              clearable 
              v-model="password" 
              :prepend-icon="e1 ? 'visibility' : 'visibility_off'"
              :prepend-icon-cb="ShowPassword"  
              name="password" 
              label="Mot de passe" 
              id="password" 
              :type="e1 ? 'text' : 'password'"></v-text-field>
            </v-form>
            <v-spacer></v-spacer>
          <v-btn color="orange darken-4"  flat router :to="'/resetpassword'">J'ai oublié mon mot de passe</v-btn>
          <v-btn v-on:click="signIn" dark block round  color="orange darken-4">Je me connecte</v-btn>

        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</v-app>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'signUp',
  data: function () {
    return {
      email: '',
      e1: false,
      Resetemail: '',
      password: '',
      dialog: false,
      resetAlert: false,
      mssg: '',
      mssgTitle: '',
      loading: false,
      rules: {
        required: (value) => !!value || 'Ce champs est requis.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Adresse e-mail invalide.'
        }
      }
    }
  },
  methods: {
    signIn: function () {
      this.loading = true
      if (!this.email || !this.password) {
        this.loading = false
        this.mssg = 'Veuillez bien remplir tous les champs.'
        this.resetAlert = true
      } else if (!this.validEmail(this.email)) {
        this.loading = false
        this.mssg = 'Adresse e-mail invalide ou non reconnue.'
        this.resetAlert = true
      } else {
        // firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.$router.push('/')
        },
        (err) => {
          this.loading = false
          this.mssg = 'Adresse e-mail ou mot de passe invalide. Veuillez vérifier vos informations et réessayer.'
          if (err.code === 'auth/invalid-email') this.mssg = 'Erreur d\'identifiant, veuillez utilisez une adresse e-mail valide.'
          this.resetAlert = true
        }
        )
      }
    },
    ShowPassword: function () {
      this.e1 ? this.e1 = false : this.e1 = true
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Authentification/Login.vue